import { render, staticRenderFns } from "./Reviewcard.vue?vue&type=template&id=6538a71c&scoped=true&"
import script from "./Reviewcard.vue?vue&type=script&lang=js&"
export * from "./Reviewcard.vue?vue&type=script&lang=js&"
import style0 from "./Reviewcard.vue?vue&type=style&index=0&id=6538a71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538a71c",
  null
  
)

export default component.exports